import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import InputField from "../../components/inputField/InputField";
import Button from "../../components/button/Button";
import styles from "./ResetPage.module.css";
import { useNavigate } from "react-router-dom";
import FunctionalButton from "../../components/button/FunctionalButton";
import { apiUrl } from "../../constants";
import Header from "../../components/header/Header";

const ResetPage = () => {
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [tokenNotValid, toggleTokenNotValid] = useState(false);
  const [success, toggleSuccess] = useState(false);

  const showNavigation = false;
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  let navigate = useNavigate();
  let { resetToken } = useParams();

  // Here we reset the password after activation mail is send.
  async function onSubmit(data) {
    toggleErrorMessage(false);
    toggleLoading(true);
    try {
      const resultValidation = await axios.get(
        `${apiUrl}/api/auth/password/reset/${resetToken}`,
        data
      );

      if (resultValidation.data.valid === true) {
        try {
          await axios.post(
            `${apiUrl}/api/auth/password/reset/${resetToken}`,
            data
          );
          toggleSuccess(true);
        } catch (e) {
          console.error(e);
        }
      } else {
        toggleTokenNotValid(true);
      }
    } catch (e) {
      toggleErrorMessage(true);
    }
    toggleLoading(false);
  }

  // When pressing the button go to the sign in page.
  function goToLoginPage() {
    navigate("/signingin");
  }

  return (
    <div>
      <Header showNavigation={showNavigation} />
      {!success && (
        <div className={styles.page}>
          <div className={styles.container}>
            <article>
              <h1>Reset password</h1>
              <form
                className={styles["reset-form"]}
                onSubmit={handleSubmit(onSubmit)}
              >
                <section>
                  <InputField
                    label="Email"
                    fieldRef={register("email", { required: true })}
                    name="email"
                    type="text"
                    id="email-sign-in-field"
                  />
                  {errors.email && (
                    <p className={styles.error}>Email is required</p>
                  )}
                </section>

                <section>
                  <InputField
                    label="Password"
                    fieldRef={register("password", { required: true })}
                    name="password"
                    type="password"
                    id="password-sign-in-field"
                  />
                  {errors.password && (
                    <p className={styles.error}>Password is required</p>
                  )}
                </section>

                <section>
                  <InputField
                    label="Confirm Password"
                    fieldRef={register("confirmPassword", { required: true })}
                    name="confirmPassword"
                    type="password"
                    id="password-sign-in-field"
                  />
                  {errors.password && (
                    <p className={styles.error}>Please confirm password</p>
                  )}
                </section>

                <section className={styles["reset-button-wrapper"]}>
                  <Button type="submit">RESET PASSWORD</Button>
                </section>

                {tokenNotValid && (
                  <p className={styles.error}>The token is invalid.</p>
                )}
              </form>

              {errorMessage && (
                <div className={styles["error-wrapper"]}>
                  <span className={styles.error}>
                    Something went wrong with resetting your password, please
                    try again later.
                  </span>
                </div>
              )}
              <div className={styles["loading-wrapper"]}>
                {loading && <p className={styles.loading}>Loading...</p>}
              </div>
            </article>
          </div>
        </div>
      )}

      {success && (
        <div className={styles.page}>
          <p>Password reset succesful</p>
          <div>
            <FunctionalButton type="button" handleClick={goToLoginPage}>
              Login
            </FunctionalButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPage;
